<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button @click="$utils.goBack($router)"   text="Quay lại" defaultHref="/tabs/main"></ion-back-button>
        </ion-buttons>
        <ion-title>Đặt vé</ion-title>
        <ion-label slot="end" style="margin-right: 2vw"></ion-label>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <GameTitle game="max4d"></GameTitle>
      <div v-if="loaded">
        <div class="options ion-padding">
          <div>
            <div>
              Cách chơi
            </div>
            <div>
              <MySelect2 :options="subgameOptions" :iconSize="'large'" :value="subgame" title="Chọn cách chơi" @change="changeSubGame"></MySelect2>
            </div>
          </div>
          <div>
            <div>
              Kỳ mua
            </div>
            <div>
              <StageSelector :options="stageOptions" :value="selectedStages" @change="changeStage" :key="updateKey"></StageSelector>
            </div>
          </div>
        </div>
        <div class="game" v-if="loaded">
          <div v-for="(card,idx) in cards" :key="card.id" class="gamecard ion-activatable" @click="editCard($event, idx)">
            <div class="title">
              {{ card.id }}
            </div>
            <div class="balls">
              <span class="ball" v-if="subgame == '4droll1'">
                <span class="balltext">&#x2217;</span>
              </span>
              <span v-for="i in numsToPick" :key="i" class="ball">
                <span class="balltext" v-if="card.nums.length > 0">{{ card.nums[i-1] }}</span>
              </span>
              <span class="ball" v-if="subgame == '4droll4'">
                <span class="balltext">&#x2217;</span>
              </span>
            </div>
            <div class="buttons">
              <ion-button color="danger" v-if="!card.selected" @click="randomPick(card)" size="small" fill="clear">
                <ion-icon :icon="dice" slot="icon-only"></ion-icon>
              </ion-button>
              <ion-button color="danger" v-if="card.selected" @click="trashCard(card)" size="small" fill="clear">
                <ion-icon :icon="trash" slot="icon-only"></ion-icon>
              </ion-button>
              <PriceInput :value="card.price" @change="priceChanged($event, card)" :title="'Nhập giá thẻ ' + card.id" />
            </div>
            <ion-ripple-effect></ion-ripple-effect>
          </div>
        </div>
      </div>
      <support-button></support-button>
    </ion-content>
    <ion-footer v-if="loaded">
      <PaySlip game="max4d" :total="total" :disabled="!purchasable" @confirmOrder="confirmOrder" :stage="parseInt(Object.keys(stageOptions)[0])"></PaySlip>
    </ion-footer>
  </ion-page>
</template>


<style>
.keno-pick .modal-wrapper{
  --background: transparent;
}
.sub-pick .modal-wrapper{
  --background: transparent;
}
</style>

<style lang="scss" scoped>

  .options {
    display: flex;
    > div {
      flex: 1;
      margin: 0 1vw;
    }
    margin-bottom: 2vh;
  }

  .payslip {
    display: grid;
    grid-template-columns: auto auto;
    margin: 0.5vh;
    margin-bottom: 1vw;
    .total {
      display: flex;
      justify-self: right;
    }
    span {
      font-weight: bold;
    }
  }
  .toolbar {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 5vw;
    .stage {
      font-size: 0.8em;
    }
  }

  .game {
    .gamecard {
      display: flex;
      flex-direction: columns;
      justify-content: space-between;
      border-bottom: 1px solid #aaa;
      position: relative;
      overflow: hidden;

      &:nth-child(1) {
        border-top: 1px solid #aaa;
      };

      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 7vw;
        color: #666;
        background-color: #f9adef;
      }

      .balls {
        display: flex;
        flex-direction: rows;
        align-items: center;
        .ball {
          margin: 0 0.5vw;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 7.5vw;
          height: 7.5vw;
          border-radius: 100%;
          border: 1px solid;
          font-size: 1.1em;
        }
        .plus {
          margin: 0 0.5vw;
          display: flex;
          align-items: center;
          height: 7vw;
        }
      }

      .buttons {
        display: flex;
        flex-direction: row;
        margin: 1vw;
        margin-right: 2vw;
        .dice, .trash {
          margin: 0 1vw;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 7vw;
          height: 7vw;
          border-radius: 100%;
          padding: 0;
          background-color: #ff34d7;
          ion-icon {
            fill: #fff;
          }
        }
      }
    }
  }
</style>

<script>
  import {
    IonContent,
    IonToolbar,
    IonFooter,
    IonPage,
    IonHeader,
    IonButtons,
    IonButton,
    IonBackButton,
    IonTitle,
    IonLabel,
    IonIcon,
    IonRippleEffect,
    modalController,
  } from '@ionic/vue';
  import { helpCircle, dice, trash, trophy } from 'ionicons/icons';
  import { random } from 'lodash';
  import Max4dPick from './Pick.vue';
  import MySelect2 from '@/components/MySelect2';
  import StageSelector from '@/components/StageSelector';
  import PaySlip from '@/components/PaySlip';
  import GameTitle from '@/components/GameTitle';
  import PriceInput from '@/components/PriceInput';
  import { defineComponent } from 'vue';

  import { cloneDeep } from 'lodash';
  import SupportButton from '@/components/SupportButton.vue';

  export default defineComponent({
    name: 'GameMax4D',
    components: {
      IonContent,
      IonToolbar,
      IonFooter,
      IonPage,
      IonHeader,
      IonButtons,
      IonBackButton,
      IonTitle,
      IonLabel,
      IonIcon,
      IonRippleEffect,
      MySelect2,
      PriceInput,
      StageSelector,
      PaySlip,
      IonButton,
      GameTitle,
      SupportButton,
    },
    data() {
      return {
        updateKey: 0,
        purchasable: false,
        showPrizeStruct: false,
        minBet: 2550,
        maxBet: 10,
        total: 0,
        loaded: false,
        numbers: [],
        idxCheckedCombo: [],
        numsToPick: 4,
        pickShowed: false,
        subgame: '4dbasic',
        subgameOptions: {
          '4dbasic': 'Max4D Cơ bản',
          '4dcombo': 'Max4D Tổ Hợp',
          '4dcover': 'Max4D Bao',
          '4droll1': 'Max4D Cuộn 1',
          '4droll4': 'Max4D Cuộn 4',
        },
        currentPickCard: 0,
        cards: [],
        priceOpts: [
        { display:'10', value: 10 },
        { display:'20', value: 20 },
        { display:'50', value: 50 },
        { display:'100', value: 100 },
        { display:'200', value: 200 },
        { display:'500', value: 500 },
        ],
        selectedStages: [],
      }
    },
    computed: {
      stageOptions() {
        if (!this.loaded) return {};
        const opts = {};
        this.$store.state.fsdb.liveMax4d.stages.forEach((stage) => {
          opts[stage.value] = {
            key: stage.value,
            display: stage.title,
            description: stage.display
          };
        });

        return opts;
      },
    },
    watch: {
      stageOptions: function(newval) {
        const keys = Object.keys(newval);

        this.selectedStages.forEach((stg, idx, arr) => {
          if (!keys.includes(stg)) {
            arr.splice(idx, 1);
          }
        });

        if (this.selectedStages.length == 0) {
          this.selectedStages.push(Object.keys(newval)[0]);
        }

        console.log('selectedStages', this.selectedStages);

        this.forceUpdate();
      }
    },
    methods: {
      forceUpdate() {
        this.updateKey += 1;
      },
      async openModal() {
        const modal = await modalController
          .create({
            component: Max4dPick,
            cssClass: 'transmodal modal-fullscreen',
            componentProps: {
              subgame: this.subgame,
              numsToPick: this.numsToPick,
              linesToShow: this.linesToShow,
              cards: this.cards,
              selectedIndex: this.currentPickCard
            },
          });
        modal.onWillDismiss().then((resp) => {
          const data = resp.data;
          if (!data.cancel) {
            this.updateCards(data.dataCards);
          }
        });

        return modal.present();
      },
      numberFormat(n) {
        return String(n).replace(/(.)(?=(\d{3})+$)/g,'$1.')
      },
      randomPick(card) {
        const picks = [];
        while (picks.length < this.numsToPick) {
          const pick = random(0, 9, false);
          picks.push(pick);
        }
        card.nums = picks;
        card.selected = true;
        this.updateTotal();
      },
      trashCard(card) {
        card.nums = [];
        card.selected = false;
        this.updateTotal();
      },
      priceChanged(e, card) {
        card.price = e;
        this.updateTotal();
      },
      editCard(event, idx) {
        this.currentPickCard = idx;
        if (event.target.classList.contains('gamecard') ||
          event.target.classList.contains('balls') ||
          event.target.classList.contains('ball') ||
          event.target.classList.contains('title') ||
          event.target.classList.contains('balltext')
          ) {
          this.pickShowed = true;
          this.openModal();
      }
    },
    onPickModalClose() {
      this.pickShowed = false;
    },
    updateCards(cards) {
      this.loadingShowed = true;
      this.pickShowed = false;
      this.cards = cards;
      this.loadingShowed = false;
      this.updateTotal();
      // modalController.dismiss().then(()=>{
      //   console.log('cards', cards);
      //   this.pickShowed = false;
      //   this.cards = cards;
      //   this.updateTotal();
      // });
    },
    changeStage(value) {
      // console.log('changeStage', value);
      this.selectedStages = value;
      this.updateTotal();
    },
    updateTotal() {
      this.updateKey += 1;
      this.total = 0;
      this.minBet = 2550;
      this.maxBet = 10;
      this.showPrizeStruct = false;
      this.cards.forEach((item) => {
        if (item.selected == true) {
          this.showPrizeStruct = true;
          if (this.minBet > item.price) {
            this.minBet = item.price
          }
          if (this.maxBet < item.price) {
            this.maxBet = item.price
          }
          if (this.subgame == '4dcover') {
            this.total += (item.price * this.calculateCombo(item.nums));
          } else {
            this.total += item.price;
          }
        }
      })
      this.total = this.total * parseInt(this.selectedStages.length)
      if (this.subgame == '4droll1' || this.subgame == '4droll4') {
        this.total = this.total * 10;
      }
      this.purchasable = this.total > 0;
    },
    resetCards() {
      this.cards = [
      { id: 'A', nums: [], price: 10, selected: false },
      { id: 'B', nums: [], price: 10, selected: false },
      { id: 'C', nums: [], price: 10, selected: false },
      { id: 'D', nums: [], price: 10, selected: false },
      { id: 'E', nums: [], price: 10, selected: false },
      { id: 'F', nums: [], price: 10, selected: false },
      ];
      this.total = 0;
      this.purchasable = false;
    },
    changeSubGame(value) {
      this.subgame = value;
      this.numsToPick = 4;
      if (this.subgame == '4droll1') {
        this.numsToPick = 3;
      }
      if (this.subgame == '4droll4') {
        this.numsToPick = 3;
      }
      this.resetCards();
      this.updateTotal();
    },
    calculateCombo(numbers)
    {
      if (numbers.length < 4) return 0;
      const numStr = numbers.sort().join('');
      const unique = /([0-9]).*(\1)/g;
      const matches = Array.from(numStr.matchAll(unique), m => m[0]);

      if (matches.length == 0) {
        return 24;
      }
      if (matches.length == 1) {
        if (matches[0].length == 2) {
          return 12;
        }
        if (matches[0].length == 3) {
          return 4;
        }
        if (matches[0].length == 4) {
          return 1;
        }
      }
      if (matches.length == 2) {
        return 6;
      }
    },
    async confirmOrder() {
      const stages = [];
      for (let i = 1; i <= parseInt(this.selectedStages); i++) {
        stages.push(i);
      }
      const data = [];
      this.cards.forEach((item) => {
        if (item.selected == true) {
          delete item['selected']
          data.push(item)
        }
      })
      if (data.length == 0) return;
      const obj = {
        subgame: this.subgame,
        stages: this.selectedStages,
        data: data
      }

      this.$utils.showLoading();

      const resp = await this.$utils.callAPI('POST', '/order/'+ this.subgame, { order: cloneDeep(obj) });

      if (resp.status == 200) {
        (await this.$utils.toast("Đặt vé thành công", {
          position: "top",
          color: "success"
        })).present();
      } else {
        if (resp.data && resp.data.message) {
          (await this.$utils.toast(resp.data.message, {position: "top"})).present();
          if (resp.data.err && resp.data.err == "INSUFFICIENT_FUND")
            this.$utils.askDeposit(this.$router);
        } else {
          (await this.$utils.toast("Có lỗi xảy ra từ máy chủ, quý khách vui lòng thử lại sau.", {position: "top"})).present();
        }
      }

      this.$utils.hideLoading();

      this.resetCards();
    }
  },
  mounted() {
    if (!this.loaded) {
      this.resetCards();
      if (this.$route.query.payload && this.$route.path == '/max4d') {

        console.log(this.$route.query.payload);
        const payload = JSON.parse(decodeURI(this.$route.query.payload));
        if (payload.ticket.subgame != '4dbasic') {
          this.changeSubGame(payload.ticket.subgame);
        }

        const cardMap = {
          'A': 0,
          'B': 1,
          'C': 2,
          'D': 3,
          'E': 4,
          'F': 5,
        }

        payload.cards.forEach((card) => {
          this.cards[cardMap[card.name]].nums = cloneDeep(card.selection);
          this.cards[cardMap[card.name]].price = Math.round(card.bet / 1000);
          this.cards[cardMap[card.name]].selected = true;
        });
        this.$nextTick(() => {
          this.loaded = true;
          this.$nextTick(() => {
            this.updateTotal();
          });
        });
      } else {
        this.$nextTick(() => {
          this.loaded = true;
        });
      }

    }
  },
  setup() {
    return {
      trophy,
      trash,
      dice,
      helpCircle,
    }
  }
});
</script>
